module.exports = "//public.zight.com/packs/media/images/card-generic-183e14526ecec8aa70638c29276b1416.png";